import { Injectable } from "@angular/core";
import { AppService, UtService } from "../../../../core/service/Base.Service";
import { GenEnum } from "../../../shared/general.enum";

@Injectable()
export class favoriteService extends UtService<any> {

    constructor() {
        super('UTFavouritemenu');
    }

    async getFavouriteList(userid, mmenuid) {
        const result = await this.get('FavouriteList', [userid, mmenuid]);
        return result
    }

    async getFavouriteScreen(userid, mmenuid) {
        const result = await this.get('FavouriteScreen', [userid, mmenuid]);
        return result
    }

}



// WEBPACK FOOTER //
// ./src/app/shell/forms/sms/menuview/Favorite.service.ts